import { render, staticRenderFns } from "./PermissionResource.vue?vue&type=template&id=15a08936&scoped=true&"
import script from "./PermissionResource.vue?vue&type=script&lang=js&"
export * from "./PermissionResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a08936",
  null
  
)

export default component.exports